import { useState } from "react";
import { admin, errorMessage } from "../lib/api";

// Până la confirmarea emailului: fără domenii proprii, membri în echipă sau chei API (restricția e în API).
export default function VerifyEmailBanner({ email }: { email: string }) {
  const [state, setState] = useState<"idle" | "sending" | "sent">("idle");
  const [error, setError] = useState<string>();
  async function resend() {
    setState("sending");
    setError(undefined);
    try {
      await admin.post("/me/verification");
      setState("sent");
    } catch (e) {
      setError(errorMessage(e));
      setState("idle");
    }
  }
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-sky-200 bg-sky-50 px-4 py-2.5 text-sm text-sky-950">
      <span>
        <b>Confirmă adresa de email</b> ({email}) din linkul pe care ți l-am trimis. Până atunci nu poți adăuga
        domeniu propriu, membri în echipă sau chei API.
      </span>
      <span className="flex items-center gap-3">
        {error && <span className="text-red-600">{error}</span>}
        {state === "sent"
          ? <span className="font-semibold text-emerald-700">Email trimis.</span>
          : <button onClick={resend} disabled={state === "sending"} className="rounded bg-sky-900/10 px-2 py-1 font-semibold hover:bg-sky-900/20">
              {state === "sending" ? "Se trimite…" : "Retrimite emailul"}
            </button>}
      </span>
    </div>
  );
}
